export function requestPermissions() {
  Notification.requestPermission()
}

export function sendIncomingCallNotification() {
  if (!document.hidden) {
    return
  }

  if (!('Notification' in window)) {
    // Check if the browser supports notifications
    // eslint-disable-next-line no-alert
    alert('This browser does not support desktop notification')
  } else if (Notification.permission === 'granted') {
    // Check whether notification permissions have already been granted;
    // if so, create a notification
    // eslint-disable-next-line no-new
    new Notification('You have a new incoming call')
  } else if (Notification.permission !== 'denied') {
    // We need to ask the user for permission
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === 'granted') {
        // eslint-disable-next-line no-new
        new Notification('You have a new incoming call')
      }
    })
  }
}

export default {
  requestPermissions,
  sendIncomingCallNotification,
}
